import PropTypes from 'prop-types';
import React, { Component } from 'react';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  searchFilterCountIfNeeded,
  searchSitesIfNeeded,
} from '../../../../../../../store/map/map.action';
import { navigateToResults } from '../../../../../../routing';
import { isSmallScreen } from '../../../../../../util/browser';
import { Box, Text } from '../../../../../../../lib/base';
import { DEFAULT_TEXT_SIZE_DESCRIPTIONS, COLOR_BASE_PRIMARY } from '../../../../../../Constants';
import ToolbarButton from '../toolbar/buttons/ToolbarButton';
import {
  IconNoLocation,
  IconWithLocation,
} from '../../../../../../components/icons/fontawesome/icons';

class LocationLessSitesButton extends Component {
  static propTypes = {
    classes: PropTypes.object,
    /**
     * Search criteria.
     */
    criteria: PropTypes.object.isRequired,
    /**
     * triggers search site sp
     */
    dispatchSearchSites: PropTypes.func,

    circular: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.handleOnClick = this.handleOnClick.bind(this);
  }

  handleOnClick() {
    /**
     * We're making a copy of the current criteria and toggling the discardLocationlessFeatures
     * property - then search with the new criteria.
     */
    const criteria = Object.assign({}, this.props.criteria, {
      discardLocationlessFeatures: !this.props.criteria.discardLocationlessFeatures,
    });

    this.props.dispatchSearchSites(criteria);

    if (!isSmallScreen()) {
      navigateToResults(this.props);
    }
  }

  render() {
    if (isSmallScreen()) {
      if (this.props.criteria.discardLocationlessFeatures) {
        return (
          <ToolbarButton
            title="Include sites that cannot be shown on the map in the list."
            onClick={this.handleOnClick}
            circular={this.props.circular}
            icon={<IconWithLocation />}
            active={false}
          />
        );
      } else {
        return (
          <ToolbarButton
            title="Do not include sites with no location."
            onClick={this.handleOnClick}
            icon={<IconNoLocation />}
            circular={this.props.circular}
            active={true}
          />
        );
      }
    } else {
      if (this.props.criteria.discardLocationlessFeatures) {
        return (
          <Box onClick={this.handleOnClick} active={false} textAlign="center" pTop="smaller">
            <Text
              size={DEFAULT_TEXT_SIZE_DESCRIPTIONS}
              color="gray"
              colorVariant="light4"
              className={this.props.classes.text}
            >
              Show sites with no locations
            </Text>
          </Box>
        );
      } else {
        return (
          <Box onClick={this.handleOnClick} active={true} textAlign="center" pTop="smaller">
            <Text
              size={DEFAULT_TEXT_SIZE_DESCRIPTIONS}
              color="gray"
              colorVariant="light4"
              className={this.props.classes.text}
            >
              Hide sites with no location
            </Text>
          </Box>
        );
      }
    }
  }
}

function mapStateToProps(state) {
  return {
    criteria: state.map.search.criteria,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchSearchSites: criteria => {
      dispatch(searchSitesIfNeeded(criteria));
      dispatch(searchFilterCountIfNeeded(criteria));
    },
  };
}

const styles = theme => ({
  text: {
    '&:hover': {
      color: theme.color[COLOR_BASE_PRIMARY]['base'],
    },
  },
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(injectSheet(styles)(LocationLessSitesButton))
);
